/* eslint-disable global-require */
if (process.env.NODE_ENV === 'development') {
  module.exports = require('./dev-server');
} else if (process.env.NODE_ENV === 'test') {
  // for integration testing this would ve useful.
  // module.exports = require('./test-server');
}
